import styled from 'styled-components';

import { Grid } from '@material-ui/core/';

export const ContainerCards = styled(Grid).attrs((props) => ({
  container: true,
  justify: props.justify,
}))``;
